import { createAction, props } from '@ngrx/store';
import { ServiceFee } from './service-fee.model';

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record serviceFee',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record serviceFee success', 
    props<{ singleData: ServiceFee }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record serviceFee failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record serviceFee',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record serviceFee success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record serviceFee failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state serviceFee',
);